<template>
  <div class="setPassWord">
    <header>
      <p v-on:click="backHistory" style="margin-left: 1rem; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">修改密码</span>
      </p>
    </header>
    <!--<header class="header divflex">-->
    <!--&lt;!&ndash;<a href="index.html" class="backlastpage"></a>&ndash;&gt;-->
    <!--<h3>首页</h3>-->
    <!--</header>-->
    <div class="main">


      <van-form @submit="onSubmit">
        <van-field class="marginTop"
                   v-model="passWord1"
                   name="请设置密码"
                   label="请输入密码"
                   placeholder="请输入密码"
                   :rules="[{ required: true, message: '请输入密码' }]"
        />
        <van-field
          v-model="passWord2" class="marginTop"
          type="password"
          name="请再次输入密码"
          label="请输入新密码"
          placeholder="请再次输入密码"
          :rules="[{ required: true, message: '请再次输入密码' }]"
        />
        <div class="marginTop">
          <van-button round block type="info" native-type="submit" @click="changePassWorder()">
            确认修改
          </van-button>
        </div>
      </van-form>

    </div>
  </div>

</template>

<script>
  export default {
    name: 'setPassWord',
    data () {
      return {
        username: '',
        passWord1: '',
        passWord2:''
      };
    },
    methods: {
      onSubmit(values) {
        console.log('submit', values);
      },
      backHistory(){
        this.$router.go(-1)
      },
      backHistory(){
        this.$router.go(-1)
      },
      changePassWorder(){//验证码登录
//        console.log(typeof Number())

//        if(this.password1===this.password2){
          this.$api.changePassWord({
//            "user_id":localStorage.getItem("userid"),
//            "pwd":this.passWord1,
//            "newpwd":this.passWord2,
             "mobile":localStorage.getItem("phone"),
            "newpassword":this.passWord2
          }).then(res=>{
              if(res.status==200){

              }
            }
          )
//        }else {
//          this.$toast("俩次密码输入不一致，请重新输入")
//        }
      },
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  /*@import '../assets/css/common.css';*/
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  header{
    width: 100%;
    height: 80px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 1rem;*/

    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .main{
    width: 90%;
    margin: 40% auto 0 auto;
  }
  .passbotwrap a {
    margin-left: 20%;
    /*display: block;*/
    line-height: 10%;
    color: #007aff;
    margin-top: 10px;
  }
  .marginTop{
    margin-top: 10%;
  }
  .van-button--block{
    width: 80%;
    margin: auto;
  }
  .setPassWord{
    /*background-color: #858585;*/
  }
  /deep/ .van-cell{
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/changePassWord.vue